var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AssertValidate, Command } from "mobx-firelink";
import { UserEdit } from "Server/CommandMacros";
import { GenerateUUID } from "Utils/General/KeyGenerator";
let AddCharacter = class AddCharacter extends Command {
    Validate() {
        const { character } = this.payload;
        AssertValidate("Character", character, "Character invalid");
        this.id = GenerateUUID();
        this.returnData = this.id;
    }
    GetDBUpdates() {
        const { character } = this.payload;
        const updates = {};
        updates["general/data/.lastCharacterID"] = this.id;
        updates[`characters/${this.id}`] = character;
        return updates;
    }
};
AddCharacter = __decorate([
    UserEdit
], AddCharacter);
export { AddCharacter };
